import { normalizeKeyName } from './normalizeKeycode';

export function shortcutToString(keysStr: string) {
	// return keysStr;
	const keys = keysStr.split('+');
	type ModifiersAndKeysTuple = [string[], string[]];
	const dividedKeys: ModifiersAndKeysTuple = keys.reduce(
		([modifiers, others]: ModifiersAndKeysTuple, cur: string): ModifiersAndKeysTuple => {
			if (isModified(cur)) {
				return [modifiers.concat([cur]), others];
			} else {
				return [modifiers, others.concat([cur])];
			}
		},
		[[], []],
	);

	const uiValue = [...dividedKeys[0], ...dividedKeys[1]].map(w => normalizeKeyName(w)).join(' ');
	return uiValue;
}
function isModified(key: string) {
	return ['meta', 'shift', 'control', 'ctrl', 'alt'].includes(key);
}
